import type { Ledge } from './types'

export type MoveChoice = 'rest' | 'stroll' | 'hop'

export const PAUSE_DWELL = { min: 1800, max: 4500 }

export function dwellMs(range = PAUSE_DWELL): number {
  return range.min + Math.random() * (range.max - range.min)
}

export function chooseMove(hasReachableHop: boolean): MoveChoice {
  const p = Math.random()
  if (hasReachableHop && p < 0.2) return 'hop'
  if (p < 0.7) return 'stroll'
  return 'rest'
}

export function pickStrollTarget(ledge: Ledge, curX: number): number {
  const span = ledge.right - ledge.left
  if (span <= 10) return curX

  const margin = Math.min(30, span * 0.1)
  const minX = ledge.left + margin
  const maxX = ledge.right - margin

  const range = (maxX - minX) * 0.4
  const dir = Math.random() < 0.5 ? -1 : 1
  const dist = (0.3 + Math.random() * 0.7) * range

  const target = curX + dir * dist
  return Math.min(maxX, Math.max(minX, target))
}
